module.exports = __webpack_public_path__ + "img/vikbet_logo_main.6178af6b.png";